module.exports = __webpack_public_path__ + "img/4f12877.png";